// store/modules/alerts.js
export default {
  state: {
    alert: {
      type: "",
      message: "",
      visible: false,
    },
  },
  mutations: {
    SET_ALERT(state, { type, message }) {
      state.alert.type = type;
      state.alert.message = message;
      state.alert.visible = true;
    },
    CLEAR_ALERT(state) {
      state.alert.type = "";
      state.alert.message = "";
      state.alert.visible = false;
    },
  },
  actions: {
    showAlert({ commit }, { type, message }) {
      commit("SET_ALERT", { type, message });
    },
    closeAlert({ commit }) {
      commit("CLEAR_ALERT");
    },
  },
  getters: {
    alert: (state) => state.alert,
  },
};
